import { v4 as uuidv4 } from "uuid";
import { chatwindowDetailsPageChange, checkInternet, FailedResend, generateChatID, notificationDataServer, userInfo } from "./utils";
import moment from "moment";
import {
  chatStatusGroupUpdate, chatStatusUpdate, clearArchiveMessage, createGroupchat,
  historyChatList, receivenewChat, recentChatList, chatTyping, chatTypingStop, presenceUpdateStatus, editMessageChat,
  clearRecentChat, updateRecentChatSettings, savedMessageList, likeMessage, fileList, getSavedList, chatLinkList, getRecentchatSaveList, deleteMessageChat,
  savedChatMySpaceListen, getMyspaceFileslist, getMyspaceLinklist, userProfileUpdated, newVoicemail, newRecordedcall, activeUserDevicesList, updateActiveDevicesList,
  loginUpdate, isJSON, getCreateMeeting, handleCancelMeeting, handelDeleteMeeting, handelAddParticipant, handelUpdateMeeting, handelMeetingNotification, saveHistoryMessage,
  getGroupCallInfo, groupCallUserStatus, initGroupInfo, groupCallMuteAll, groupCallEnd, grpCallSpeechStatus, incomingLog, outgoingLog, missedLog, syncDeleteLog, getInstantMeeting, RingingStopNotification, updatingHost, checkpresenceUpdateStatus, getRunningGroupCalls, handleVideocallRequest, handleVideocallAccept, handleVideocallCancel, handleCallConnectedInfo
  , handleCompletedMeeting, handleOngoingMeeting, callConnected, flipCall, handleDirectVideocallRequest, handleDirectVideocallAccept, handleDirectVideocallCancel, accpectVideoCallDirect, rejectVideoCallDirect, getRecording, bulkChatUpdate, update, MeetingStatusRead, shareStatus, setAllContact, getTranscripts, storeAudioTranscript, aiAssist
} from "./newChat";

import { historyGroupList, newGroupChat, newMembersGroup, removeMembersGroup, teamAdminChange, updateGroupDetailsInfo, leaveMembersGroup, ClearChat } from "./groupChat";
import store from "../../context/store/store";
import { actionTypes, Types } from "../../context/action/action";
import { blockSignOut, checkLinkMessage, closeVideoCallRinging, closeVideoRinging, Cookie, getCookie, getTeamMemberContact, getTimeDiffer, imageFormat, scrollIntoView } from "../utils";
import { chats, chatwindowDetails, contactSync, loginReducerState, LoginState } from '../../models/model'
import { ChatService } from "../chatService";
import { chatSDK } from "unifiedring-sdk";
import { DraftService } from "../draftService";
import { config } from "../constant";
import { determineIps, storePlanBasedFeatures, toastInformation, videoCallReqNotfy } from "../callService/common";
import _ from "lodash";
import { createCallConnection, sendDTMF } from "../callService/callService";
import { showBrowserNotification } from "../notification";
import { stat } from "fs";
import { updateMeetingRead, updateMeetingTotalBatch } from "../meetingService/apiService";
import { storeLogs, storeParticularLog } from "../callService/store_mining";
import axios from "axios";
import { contactService } from "../contactService";

let socketInit: boolean = false;
let socketConnectionInstese: any = ""
export class SocketChatService {
  socketConnection: any;
  static _instance: any;
  eventEmit: any;
  current: any;
  // getFlipCall: string;
  // static getFlipCall: any;
  constructor(sipid: string, domainid: number, url?: string) {
    const cookieData: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    let tokenData: any = cookieData["ssoToken"];
    let userInfo: any = userInfosess;
    
    if (tokenData && userInfo && sipid && domainid) {
      const parsedUserInfo = JSON.parse(userInfo);
      this.socketConnection = new chatSDK.ChatSocketClient(sipid, domainid, config().URCHAT_SOCKETIO_URL, tokenData, parsedUserInfo?.caller_id)
      
      socketConnectionInstese = this.socketConnection;

      this.eventEmit = this.socketConnection.getEventEmitter();
      let self = this;
      if (!SocketChatService._instance) {
        self?.InitSocketEvents();
      } else {
        return;
      }
      SocketChatService._instance = this;
      socketInit = true;
    } else {
      this.socketConnection = socketConnectionInstese;
    }
  }
  public getAllBellNotification = () => {
    if (this.socketConnection) {
      this?.socketConnection?.getBellNotifications();
    }
  };
  public CreateChat(sipID: string) {
    this.socketConnection.createChat({ receiver: sipID });
  }

  public Savehistory(data: any) {
    this.socketConnection.savedChatHistory(data)
  }
  public chatTypingStatusUpdate(data: any) {
    this.socketConnection.chatTypingstatus(data)
  }
  public chatTypingStopped(data: any) {
    this.socketConnection.chatTypingStoppedStatus(data)
  }

  public editGroupInfo(data: any) {
    this.socketConnection.updateGroupInfo(data);
  }

  public markAsRead(contact: any) {
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;

    if(contact?.unreadCount > 5){
      this.socketConnection.markallread({ chatId: contact.chatId, from: contact.lastmessage.from , chatType:1});
    } else {
      this.socketConnection.markAsRead({ chatId: contact.chatId });
    }

    if (contact.type === 1) {
      const toUsers = parseInt(contact.to);
      recentChatList[toUsers].unreadCount = 0;
    } else {
      recentChatList["con" + contact.chatId].unreadCount = 0;
    }
    // this.socketConnection.markAsRead({ chatId: contact.chatId });
    store.dispatch({
      type: actionTypes.RECENT_MESSAGE_LIST,
      payload: {
        recentChatList: recentChatList,
        recentLoading: true
      }
    });
  }
  public alldeveiceBadgeCount(data: any) {
    this.socketConnection.badgeCount(data)
  }

  public videoCallAccept(data: any) {

    console.log("data >>>>>final", data);
    this.socketConnection.videoCallAccept(data)
  }

  public directvideoCallAccept(data: any) {

    console.log("meetvideoCallAccept >>>>>final", data);
    this.socketConnection.meetvideoCallAccept(data)
  }

  public videoCallCancel(data: any) {
    console.log("videoCallCancel final", data);
    this.socketConnection.videoCallCancel(data)
  }
  public directvideoCallCancel(data: any) {
    console.log("directvideoCallCancel final", data);
    this.socketConnection.meetvideoCallCancel(data)
  }

  public sendMeetCallCheck() {
console.log("meet call checkeddddddd")
    this.socketConnection.meetCallCheck({});
  }


  public toastUndo(toast: string, callback: any, key: string = '') {
    store.dispatch({
      type: Types.TOAST_UNDO,
      payloads: {
        toastMessage: toast,
        callback: callback,
        key: key
      }
    });
  }

  public toggleUndo(undo: boolean) {
    store.dispatch({
      type: Types.TOAST_UNDO_CLICK,
      payloads: {
        undo: undo
      }
    });
  }


  public destroy() {
    if (this.socketConnection) {
      this.socketConnection.removeAllEventListeners();
    }
    SocketChatService._instance = null;
    this.socketConnection = null;
    this.eventEmit = null;
  }
  public FailedNewChat(chat: string, list?: any, replyMsg?: any) {
    const toastReducer: any = store.getState().toastReducer;
    if (toastReducer?.internet === false) {
      this.socketConnection.newChat();
    }
  }
  public FailedResendChat(chat: any) {
    if(chat?.type === 2 ){
      this.socketConnection?.newGroupChat(chat?.id, 2,chat?.timestamp, chat?.from,
        chat?.to, chat?.chatId, chat?.message);
    } else {
      this.socketConnection.newChat(chat);
    }
     
  }


  public NewChat(chat: string, list?: any, replyMsg?: any) {
    let listMsg: any = replyMsg === undefined ? list : !_.isUndefined(replyMsg?.direction) && replyMsg?.direction === 'IN';
    let frdMsg: any = replyMsg?.message?.forward === true ? replyMsg?.message?.forward : false;
    const toastReducer: any = store.getState().toastReducer;
    const userDetails = userInfo();
    const toID = list?.sip_login_id?.toString() ? list?.sip_login_id?.toString() : userDetails?.toID?.toString();
    let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
    let { replyMessageDetails }: chats = store.getState().chatReducer;
    let link = checkLinkMessage(chat);
    let thred = replyMsg?.isReply && (replyMsg?.replymessage?.message?.threadId !== "" && _.isUndefined(replyMsg?.replymessage?.message?.threadId) === false) ? replyMsg?.replymessage?.message?.threadId : replyMsg?.replymessage?.id
    let messageDetails: any = {
      from: userDetails.fromID.toString(), sourceTimestamp: moment().valueOf(), to: toID?.toString(),
      chatId: generateChatID(userDetails.fromID, toID), message:
      {
        messageType: "TEXT", body: chat?.trim(), replyMsgBody: replyMsg?.replymessage, isLink: link, isEdit: false,
        isReply: replyMsg?.isReply ? true : false, threadId: replyMsg?.isReply ? thred : "", forward: listMsg ? true : frdMsg
      },
      id: uuidv4()
    };
    let contactRed = store.getState().contactReducer;
    let { workContactsnew, teamContacsnew }: any = contactRed;
    if (toastReducer?.internet === true) {
      messageDetails.deliveryStatus = 1;
      messageDetails.readStatus = 0;
      messageDetails.createdAt = new Date().toISOString();
      messageDetails.updatedAt = new Date().toISOString();
      messageDetails.timestamp = moment().valueOf();
      messageDetails.fromcaller_details = chatWindowDetails?.sip_login_id ? workContactsnew[chatWindowDetails?.sip_login_id] :
        teamContacsnew["con" + chatWindowDetails?.team_id];
      messageDetails.type = chatWindowDetails?.sip_login_id ? 1 : 2;
      DraftService.addFailedMessage(chatWindowDetails, messageDetails);
    } else {

      this.socketConnection.newChat(messageDetails);

      messageDetails.deliveryStatus = 2;
      messageDetails.readStatus = 0;
      messageDetails.createdAt = new Date().toISOString();
      messageDetails.updatedAt = new Date().toISOString();
      messageDetails.timestamp = moment().valueOf();
      messageDetails.fromcaller_details = chatWindowDetails?.sip_login_id ? workContactsnew[chatWindowDetails?.sip_login_id] :
        teamContacsnew["con" + chatWindowDetails?.team_id];
      messageDetails.type = chatWindowDetails?.sip_login_id ? 1 : 2;
      if (!chatWindowDetails?.team_id && chatWindowDetails?.sip_login_id === messageDetails.to) {
        DraftService.sendMessageBefore(messageDetails);
      }
      replyMessageDetails.isReply && ChatService.onChangeReplyWindow(false, "");
      chatwindowDetailsPageChange(chatWindowDetails);

    }
  }

  public updateNewMessage(chat: string, contact: any) {
    const userDetails = userInfo();
    let { messageList }: any = store.getState().chatSocketReducerState;
    const fromUser = parseInt(userDetails.fromID);
    const fromCallerDetails = userInfo().workContactObj[fromUser];
    const messageDetails = {
      from: userDetails.fromID.toString(), sourceTimestamp: moment().valueOf(), to: userDetails.toID.toString(),
      chatId: generateChatID(userDetails.fromID, contact.sip_login_id), message:
        { messageType: "TEXT", body: chat, forward: false },
      id: uuidv4(),
      direction: "OUT",
      fromcaller_details: fromCallerDetails
    };
    store.dispatch({
      type: actionTypes.MESSAGE_LIST,
      payload: {
        messageList: [...messageList, messageDetails],
        messageLoading: false
      }

    });

  }

  public displayNewContact(contactdetails: any) {
    // store.dispatch({
    //   type: Types.OPEN_CHAT_WINDOW,
    //   payload: {
    //     isChatWindow: true,
    //     chatWindowDetails: contactdetails,
    //     isMySpace: false,
    //     isNewMessageWindow:false
    //   }
    // });
  }

  public sendNewMessage(chat: string, contact: any) {
    const userDetails = userInfo();
    const messageDetails = {
      from: userDetails.fromID.toString(), sourceTimestamp: moment().valueOf(), to: userDetails.toID.toString(),
      chatId: generateChatID(userDetails.fromID, contact.sip_login_id), message:
        { messageType: "TEXT", body: chat, forward: false },
      id: uuidv4()
    };
    this.socketConnection.newChat(
      messageDetails);
  }
  public updateNoteData = (updateData: any) => {
    new chatSDK.ChatRestService().updateStatusNote(updateData).then((res: any) => {
      if (res?.statusCode === 200) {
        // let activeStatus :any= res?.user_status?.status_msg;
        // let type = res?.user_status?.type;
      }
    });
  }
  public InitSocketEvents() {

    this.eventEmit.on("connect_failed", (msg: any) => {
      console.log("connection Failed");
    });
    this.eventEmit.on("connect_error", (msg: any) => {
      console.log("connect_error!!!", msg);

      if (msg && msg?.message && isJSON(msg?.message)) {
        const parsedMessage = JSON.parse(msg?.message);
        if (parsedMessage?.code === 403) {
          loginUpdate();
        }
        if (parsedMessage?.message === "invalid token") {
          const cookieData: any = Cookie.get();
          const userInfosess: any = sessionStorage.getItem("userinfo");
          let tokenData: any = cookieData["ssoToken"];
          let userInfo: any = userInfosess;

          if (userInfo && tokenData) {
            // console.log(tokenData,"SRUUUU --->",userInfo);
            // let updatedInfo = JSON.parse(userInfo);
            // const socketChat = new SocketChatService(updatedInfo.fromID, updatedInfo.domainId, config().URCHAT_SOCKETIO_URL);
          }
        }

      }
      // window.location.hash = 
    });
    this.eventEmit.on("connect", async (message: any) => {
      console.log("Connected!!!----------------------")
      // clearArchiveMessage();
      // ChatService.openContactWindow({});
      //clearRecentChat(false);
      this.socketConnection.getSaveChatList({});
      let data: any = { status: 1 }
      let datares: any = { status: "1" }
      this.socketConnection.checkPresenceStatus(datares);
      //this.socketConnection.userPresenceStatusUpdate(data);

      this.socketConnection?.getUserInfo({timestamp :0});
      // this.eventEmit.emit("userpresence_status_update", {status :1}, (message:any) => {
      //   console.log("userpresence_status_update-------->",message,USERPRESENCESTATUSUPDATE);
      // });
      const timeoutref = setTimeout(() => {
        let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
        const recentChatArray = Object.values(recentChatList);
        if (recentChatArray?.length === 0) {
          store.dispatch({
            type: actionTypes.RECENT_LOADING,
            payload: {
              recentLoading: true
            }
          });
          ChatService.emptyOnMyspace();
        }
        else {
          clearTimeout(timeoutref);

        }
      }, 8000);
      FailedResend();
      const cookieData: any = Cookie.get();
      const userInfosess: any = sessionStorage.getItem("userinfo");
      if (cookieData && userInfosess) {
        console.log('Login user info',JSON.parse(userInfosess));
        console.log('cookieData----------',cookieData.startTour)
        // if(JSON.parse(userInfosess).is_tour_flag===1&&cookieData.startTour!=='1'){
        //   console.log('coming inside the log od sock service');
          
        //   Cookie.set('startTour', '0',365);

        // };

        let ipDetails: any = await determineIps();
        if (ipDetails?.isIPChanged) {
          createCallConnection(JSON.parse(userInfosess), ipDetails.IP);
          console.log('Login user info',JSON.parse(userInfosess));
          // if(JSON.parse(userInfosess).is_tour_flag_web===0){
          //   localStorage.setItem('startTour','1')
          // };
        
        }
      }
    });
    this.eventEmit.on("deletedUser", (message: any) => {
      let objectList: any = [];
      objectList = [...message?.deletedUser].reduce((acc: any, curr: any) => {
        //const participant: any = userstatus[curr.sip_login_id];
        if (curr?.sip_id && curr["sip_id"]) {
          curr['sip_login_id'] = curr?.sip_id.toString();
          return (acc[curr["sip_id"]] = curr, acc);
        } else {
          return null;
        }
      }, {});

      store.dispatch({
        type: Types.DELETE_CONTACT,
        payload: {
          deleteContacts: objectList
        }
      })

    });
    this.eventEmit.on("update_recentchat_setting", updateRecentChatSettings.bind(null, this.socketConnection))
    this.eventEmit.on("groupchat_delivered", chatStatusGroupUpdate);
    this.eventEmit.on("groupchat_readstatus", chatStatusGroupUpdate);
    this.eventEmit.on("urrecentchat", recentChatList.bind(null, this.socketConnection));
    this.eventEmit.on("new_groupchat", newGroupChat.bind(null, this.socketConnection));
    this.eventEmit.on("clear_chat_messages", ClearChat.bind(null, this.socketConnection));
    this.eventEmit.on("new_chat", receivenewChat.bind(null, this.socketConnection));
    this.eventEmit.on("history_chat", historyChatList.bind(null, this.socketConnection));
    this.eventEmit.on("chat_readstatus", chatStatusUpdate);
    this.eventEmit.on("chat_delivered", chatStatusUpdate);
    this.eventEmit.on("create_groupchat", createGroupchat.bind(null, this.socketConnection));
    this.eventEmit.on("add_members", newMembersGroup.bind(null, this.socketConnection));
    this.eventEmit.on("remove_members", removeMembersGroup.bind(null, this.socketConnection));
    this.eventEmit.on("history_groupchat", historyGroupList.bind(null, this.socketConnection));
    this.eventEmit.on("leave_member", leaveMembersGroup.bind(null, this.socketConnection));
    this.eventEmit.on("role_change", teamAdminChange.bind(null, this.socketConnection));
    this.eventEmit.on("update_group", updateGroupDetailsInfo.bind(null, this.socketConnection));
    this.eventEmit.on("save_chat", savedMessageList.bind(null, this.socketConnection));
    this.eventEmit.on("like_message", likeMessage.bind(null, this.socketConnection));
    this.eventEmit.on("file_list_chat", fileList.bind(null, this.socketConnection));
    this.eventEmit.on("link_list_chat", chatLinkList.bind(null, this.socketConnection));
    this.eventEmit.on("newmessage_group", this.newMessageGroupSuccess);
    this.eventEmit.on("user_profile_update", userProfileUpdated.bind(null, this.socketConnection));
    this.eventEmit.on("new_voicemail", newVoicemail);
    this.eventEmit.on("new_callRecording", newRecordedcall);
    this.eventEmit.on('active_devices', activeUserDevicesList);
    this.eventEmit.on('active_devices_change', updateActiveDevicesList);
    this.eventEmit.on('create_meeting', getCreateMeeting);
    this.eventEmit.on('recording_stop', getRecording);
    this.eventEmit.on('hostjoined_notification', getInstantMeeting);
    this.eventEmit.on('cancel_meeting', handleCancelMeeting);
    this.eventEmit.on('delete_meeting', handelDeleteMeeting);
    this.eventEmit.on('add_participant', handelAddParticipant);
    this.eventEmit.on('update_meetings', handelUpdateMeeting);
    // this.eventEmit.on('participant_status', update);
    this.eventEmit.on('meeting_notification', handelMeetingNotification);
    this.eventEmit.on('get_notification_history', notificationDataServer);
    this.eventEmit.on('call_team_info', getGroupCallInfo); //
    this.eventEmit.on('GroupCallUserStatus', groupCallUserStatus); // participant status comming ontime.
    this.eventEmit.on('CallTeamInfo', initGroupInfo);
    this.eventEmit.on('audiocc',getTranscripts);
    this.eventEmit.on('group_call_mute', groupCallMuteAll);
    this.eventEmit.on('GroupCallEnd', groupCallEnd);
    this.eventEmit.on('completed_notification', handleCompletedMeeting);
    this.eventEmit.on('meeting_read_status', MeetingStatusRead);
    this.eventEmit.on('ongoing_notification', handleOngoingMeeting);

    this.eventEmit.on("user_presence_status", (message: any) => {
      //presenceUpdateStatus(message);
    });
    this.eventEmit.on("check_presence_status", (message: any) => {
      checkpresenceUpdateStatus(message)

    });
    this.eventEmit.on("team_profile_update", (message: any) => {
      let contactRed = store.getState().contactReducer;
      let { teamContacsnew }: any = contactRed;
      teamContacsnew['con' + message?.team_id].profile_image_thumbnail = message?.profile_image_thumbnail;
      teamContacsnew['con' + message?.team_id].profile_image_url = message?.profile_image_thumbnail;

    });

    this.eventEmit.on('group_call_host', updatingHost);

    this.eventEmit.on("jenkins_message", (mesg: any) => {

      store.dispatch({
        type: Types.JENKINS_MESSAGE,
        payload: {
          jenkinMessage: true
        }
      })
    });
    this.eventEmit.on("new_plan_update", (mesg: any) => {
      console.log("mesg",mesg)
      storePlanBasedFeatures(mesg?.data);
    });
    this.eventEmit.on('group_call_speech_status', grpCallSpeechStatus);
    this.eventEmit.on('active_group_calls', getRunningGroupCalls);
    this.eventEmit.on('inboundCall', incomingLog);
    this.eventEmit.on('outboundCall', outgoingLog);
    this.eventEmit.on('missedCall', missedLog);
    this.eventEmit.on('delete_call_list', syncDeleteLog);
    this.eventEmit.on('meetcall_ringing_status', RingingStopNotification.bind(null, this.socketConnection));
    this.eventEmit.on('i_have_joined', RingingStopNotification.bind(null, this.socketConnection));
    this.eventEmit.on('i_have_rejected', RingingStopNotification.bind(null, this.socketConnection));

    this.eventEmit.on('i_have_joined_meet',(msg:any)=>{
    let { userdetails }: loginReducerState = store.getState().loginReducer;
    let meetingReducer: any = store.getState().meetingReducer;
    const {ringStatus} =meetingReducer;
    store.dispatch({
      type: Types.VIDEOCALL_RING_STATUS,
      payload: {
       ringStatus:false
      }
    })
      
        console.log(ringStatus,"after ringStatus=====");
       
      if(msg){
        if(ringStatus ){
          accpectVideoCallDirect(msg)
        }else{
          console.log("MobileDeviceAccpect_VCall_ Invitation Closed Web");
          var videoRinger: any = document.getElementById("videoringer");
          var promoseVide:any = videoRinger.pause();
          store.dispatch({
            type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
            payload: {
                meetingDetails: {},
                isVideocallRingvideo: false,
                isDirectVideocall: false
            }
        })
        
        console.log(ringStatus,"after ringStatus=====");
        }
      }
    });
    this.eventEmit.on('i_have_rejected_meet',(msg:any)=>{
      if(msg){
        videoCallReqNotfy("reject",msg)
      }
    });;

    //this.eventEmit.on('video_call_request', handleVideocallRequest.bind(null, this.socketConnection));
   this.eventEmit.on('call_connected', callConnected);
    this.eventEmit.on('call_flip', flipCall);


    this.eventEmit.on("video_call_request", (mesg: any) => {
      setTimeout(() => {
        console.log("video meet ringing trigger");

        closeVideoCallRinging();
      }, 50000)
      handleVideocallRequest(mesg)
      updateMeetingTotalBatch();
    });

    this.eventEmit.on("video_call_accept", (mesg: any) => {
      console.log("video_call_accept >>>>>>", mesg);
      handleVideocallAccept(mesg)
    });

    this.eventEmit.on("video_call_cancel", (mesg: any) => {
      console.log("video_call_cancel >>>>>>", mesg);
      handleVideocallCancel(mesg);
      updateMeetingTotalBatch();
    });

    this.eventEmit.on("meet_call_request", (mesg: any) => {
      console.log("meet_call_request >>>>>>", mesg);
      let meetingStatusCheck: any = getCookie("meetingStatus") ? true : false;
      console.log("meetingStatusCheck>>>>",meetingStatusCheck);
      if(!meetingStatusCheck)
      {var videoRinger: any = document.getElementById("videoringer");
      var promoseVide:any = videoRinger.play();}

      setTimeout(() => {
        console.log("video meet ringing trigger");
        
        // closeVideoRinging();
        closeVideoCallRinging();
      }, 50000)
      handleDirectVideocallRequest(mesg)
      updateMeetingTotalBatch();
    });

    this.eventEmit.on("meet_call_accept", (mesg: any) => {
      console.log("meet_call_accept >>>>>>", mesg);
      handleDirectVideocallAccept(mesg)
    });

    this.eventEmit.on("meet_call_cancel", (mesg: any) => {
      console.log("meet_call_cancel >>>>>>", mesg);
      handleDirectVideocallCancel(mesg)
    });


    this.eventEmit.on("call_connected", (mesg: any) => {
      
    let {rightSideWindow}=store.getState().updatedCallList;

      let {audioTranscript,transcriptLoading}=store.getState().closeCaption;
      console.log("call_connected >>>>>>", mesg);
      
      // handleVideocallCancel(mesg)
      if(mesg.status === "disconnected"){storeAudioTranscript([],true,true);}
      handleCallConnectedInfo(mesg)
    });

    this.eventEmit.on("voicemail_read", (mesg: any) => {
      let { logs,particularLog }: any = store.getState().callReducer||[];

      for (let i = 0; i < logs.length; i++) {
        if (mesg.vmarraylist.includes(logs[i].Vm_uuid)) {
            logs[i].ReadFlag = mesg.ReadFlag;
        }
    }
      storeLogs(logs);
      if (particularLog.Vm_uuid === mesg.vmarraylist) {
        particularLog.ReadFlag = mesg.ReadFlag;
        storeParticularLog(particularLog? particularLog :{},false);
      }
    });
    



    // this.eventEmit.on('group_call_speech_status',grpCallSpeechEventLisenter);
    this.eventEmit.on("clear_chat_messages", (mesg: any) => {

      let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
      let self = this;
      console.log("Clear Chat Message --->", mesg);
      self?.fetchChatHistory(chatWindowDetails);
      store.dispatch({
        type: Types.CHAT_CLEAR_MESSAGE,
        payload: {
          clearChatMsg: mesg
        }
      })
    });
    this.eventEmit.on("addParticipant_notification", (status: any) => {
      try{
        
        if(status !== null){
          let meetingStatusCheck: any = getCookie("meetingStatus") ? true : false;
        console.log("status>>>>>>>>>",status);
        console.log("meetingStatusCheck",meetingStatusCheck);
        if(!meetingStatusCheck){
           var videoRinger: any = document.getElementById("videoringer");
      var promoseVide:any = videoRinger.play();}
    setTimeout(() => {
      closeVideoRinging();
      let token: any = getCookie("ssoToken");
      var authkey = {
        "Content-Type": "application/json",
        Authorization: token
      };
      axios
      .get(`${config().MEET_RESTAPI_URL}/rejected/${status.meetingId}`, { headers: authkey })
      .then((response: any) => {
        if (response.data && response.data.statusCode === 200) {
         console.log("ringing notification");
         store.dispatch({
          type: Types.VIDEOMEET_COUNT_STATUS,
          payload: {
            meetingCountStatus:true
          }
        })
         updateMeetingRead(status?.meetingId);
        }
      });
    }, 50000)
    updateMeetingTotalBatch();
    store.dispatch({
      type: Types.VIDEO_MEET_RING_NOTIFICATION,
      payload: {
        meetingDetails: status,
        isRingvideo: true
      }
    })
    if (document.visibilityState !== "visible") {
      console.log("visble on ");
      const inputOptions = {
        userName: status.meetingName,
        url: status.inviteUrl,
        message: "Invitation From" + status.hostDetails.name + '(Host) \n'
      };
      showBrowserNotification(inputOptions, "meeting")
    }
  }
      }catch(error:any){
        console.log("addParticipant_notification not initialize");
      }
    });

    this.eventEmit.on("presenceStatus", (status: any) => {
      // let contactRed = store.getState().contactReducer;
      // let { workContacts, allContacs, workContactsnew, allContactsNew, teamContacsnew, teamContacs }: any = contactRed;
      // let wIndex = workContacts.findIndex((value: any) => value?.sip_login_id === status?.sipLoginId);
      // let allContacsIndex = allContacs.findIndex((value: any) => value?.sip_login_id === status?.sipLoginId);
      // if (wIndex > -1 && allContacsIndex > -1) {
      //   workContacts[wIndex].user_status = status?.status_msg;
      //   allContacs[allContacsIndex].user_status = status?.status_msg;
      //   workContactsnew[status.sipLoginId].user_status = status?.status_msg;
      //   store.dispatch({
      //     type: Types.UPDATE_ALL_CONTACTS,
      //     payload: {
      //         allContactsNew: allContactsNew,
      //         teamContacsnew: teamContacsnew,
      //         teamContacs: teamContacs,
      //         workContactsnew: workContactsnew,
      //         allContacs: allContacs,
      //         workContacts: workContacts
      //     }
      //   });
      //   let { chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;


      // if(chatWindowDetails?.sip_login_id===status?.sipLoginId){
      //   store.dispatch({
      //     type: Types.SET_CONTACT_WINDOW,
      //     payload: {
      //         chatWindowDetails: workContactsnew[status.sipLoginId]
      //     }
      // });
      // }

      // }
      // let { userdetails }: loginReducerState = store.getState().loginReducer;
      // if (userdetails?.sip_login_id === status?.sipLoginId) {
      //   userdetails.user_status = status.status_msg;

      //   store.dispatch({
      //     type: Types.ADD_LOGIN,
      //     payload: { userdetails: userdetails }
      //   });
      // }


    });
    this.eventEmit.on("shareStatus", (status: any) => {
      console.log(status,"status====");

      let contactAllReducer = store.getState().contactReducer;
      let {  allContacs }: any = contactAllReducer;
      // let indtttex:number=0;
      Array.isArray(allContacs) && allContacs.map((element: any,index:any) => {
       if (element?.sip_login_id?.toString() === status?.sipLoginId) {
            element.status_msg = status.status_msg;
            // indtttex = index;
        }
    });
      setAllContact(allContacs);
      
    });
    this.eventEmit.on("save_history_message", (status: any) => {
      saveHistoryMessage(status);

    });
    this.eventEmit.on("new_contact", (contactlist: any) => {
      let contactRed = store.getState().contactReducer;
      let { userdetails }: loginReducerState = store.getState().loginReducer;
      let { workContacts, allContacs, workContactsnew, allContactsNew, teamContacsnew, teamContacs }: any = contactRed;
      let { chatWindowDetails }: any = store.getState().chatWindowReducer;
      if (allContacs && contactlist?.status === "Added" && Array.isArray(contactlist?.companyContacts)) {
        // allContacs?.contact(contactlist?.companyContacts);
        workContactsnew[contactlist?.sip_login_id] = contactlist?.companyContacts[0];
        workContacts = [...workContacts, ...contactlist?.companyContacts];
        allContacs = [...allContacs, ...contactlist?.companyContacts];
        allContactsNew =  [...allContacs, ...contactlist?.companyContacts];
     
      }
     
      if(contactlist?.status === "block"){
        if(userdetails?.sip_login_id === contactlist?.sip_login_id){
          blockSignOut();
        } else {
        let wIndex = workContacts.findIndex((value: any) => `${value?.sip_login_id}` === contactlist?.sip_login_id);
       // workContacts[wIndex].is_blocked = 1
         let allContacsIndex = allContacs.findIndex((value: any) => value?.sip_login_id === parseInt(contactlist?.sip_login_id));
         if(allContacsIndex !== -1){
          allContacs[allContacsIndex].is_blocked = 1
          // allContactsNew[allContacsIndex].is_blocked = 1;
           //workContactsnew[contactlist?.sip_login_id].is_blocked = 1;
         }
   
        if(chatWindowDetails?.sip_login_id === parseInt(contactlist?.sip_login_id)){
          chatWindowDetails['is_blocked'] = 1;
        }
      }
      }
      if(contactlist?.status === "unblock"){
        let wIndex = workContacts.findIndex((value: any) => `${value?.sip_login_id}` === contactlist?.sip_login_id);
       // workContacts[wIndex].is_blocked = 1
         let allContacsIndex = allContacs.findIndex((value: any) => parseInt(value?.sip_login_id) === parseInt(contactlist?.sip_login_id));
        allContacs[allContacsIndex].is_blocked = 0
       // allContactsNew[allContacsIndex].is_blocked = 0;
        workContactsnew[contactlist?.sip_login_id].is_blocked = 0;
        if(chatWindowDetails?.sip_login_id === parseInt(contactlist?.sip_login_id)){
          chatWindowDetails['is_blocked'] = 0;
        }
      }
     
      if (contactlist?.status === "Deleted" && Array.isArray(contactlist?.companyContacts)) {
        if(contactlist?.sip_login_id === userdetails?.sip_login_id){
          blockSignOut();
        } else{
          let wIndex = workContacts.findIndex((value: any) => `${value?.sip_login_id}` === contactlist?.sip_login_id);
          let allContacsIndex = allContacs.findIndex((value: any) => `${value?.sip_login_id}` === contactlist?.sip_login_id);
          allContacs.splice(allContacsIndex, 1);
          workContacts.splice(wIndex, 1);
          delete workContactsnew[contactlist?.sip_login_id];
          
          this.socketConnection?.getUserInfo({ timestamp: 0 });
        }
      }
      if (contactlist?.status === "Updated"  && contactlist?.companyContacts
        && contactlist?.companyContacts.length > 0) {
        let wIndex = workContacts.findIndex((value: any) => `${value?.sip_login_id}` === contactlist?.sip_login_id);
        workContacts[wIndex] = contactlist?.companyContacts[0];
        let allContacsIndex = allContacs.findIndex((value: any) => value?.sip_login_id === contactlist?.sip_login_id);
        allContacs[allContacsIndex] = contactlist?.companyContacts[0];
        allContactsNew[contactlist?.sip_login_id] = contactlist?.companyContacts[0];
        workContactsnew[contactlist?.sip_login_id] = contactlist?.companyContacts[0];
      }
    
      store.dispatch({
        type: Types.UPDATE_ALL_CONTACTS,
        payload: {
          allContactsNew: allContactsNew,
          teamContacsnew: teamContacsnew,
          teamContacs: teamContacs,
          workContactsnew: workContactsnew,
          allContacs: allContacs,
          workContacts: workContacts
        }
      })

    })

    this.eventEmit.on("link_list_myspace", getMyspaceLinklist);

    this.eventEmit.on("file_list_myspace", getMyspaceFileslist);

    this.eventEmit.on("save_message_myspace", savedChatMySpaceListen.bind(null, this.socketConnection));
    this.eventEmit.on("disconnect", (msg: any) => {
      try{
        checkInternet(true);
        // let updateData: any = {};
        // updateData.status_msg = "Appear Offline";
        // updateData.manualFlag = 0;
        // updateData.timeDuration = "4";
        // updateData.userStatusStimestamp = 0;
        // updateData.prevStatus = 0;
        // updateData.status_indicator = 6;
        // updateData.type = 2;
        // this.updateNoteData(updateData)
  
        if (msg === "io server disconnect") {
          loginUpdate();
        }
      } catch (error) {
        console.log('getGroupCallInfo error is -->>', error)
    }
    });
    this.eventEmit.on("save_message_chat", getSavedList.bind(null, this.socketConnection));
    this.eventEmit.on("mark_us_read", chatStatusUpdate);
    this.eventEmit.on("mark_all_as_read", bulkChatUpdate);
    //this.eventEmit.on("delete_for_everyone", getDeleteEveryOne.bind(null, this.socketConnection));
    // this.eventEmit.on("edit_message", (userStatus: any) => {

    //   editMessageChat(null, userStatus);
    // });
    this.eventEmit.on("delete_for_everyone", (userStatus: any) => {
      deleteMessageChat(userStatus);
    });
    this.eventEmit.on("save_message_rechantchat", getRecentchatSaveList);

    this.eventEmit.on("edit_message", (userStatus: any) => {
      let { messageList }: any = store.getState().chatSocketReducerState;
      let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
      const messageDetails = messageList[messageList.length - 1];
      console.log("userStatus --->", userStatus);
      const userDetailsnew = userInfo();
      const currUser = parseInt(userDetailsnew.fromID);
      const recentID = parseInt(userStatus.from) !== currUser ? userStatus.from : parseInt(userStatus.to) !== currUser ? userStatus.to : "";

      if (userStatus?.id) {
        let msgText: any =
          userStatus?.message?.messageType === "TEXT"
            ? userStatus?.message?.body
            : userStatus?.message?.messageType === "IMAGE" && userStatus?.message?.body?.fileType?.includes("gif")
              ? "GIF"
              : userStatus?.message?.messageType === "FILE" || userStatus?.message?.messageType === "IMAGE"
                ? "shared a file"
                : userStatus?.message?.messageType === "GEO"
                  ? "Shared a geo location"
                  : userStatus?.message?.messageType === "NOTE"
                    ? "Shared a notes"
                    : userStatus?.message?.messageType === "TASK"
                      ? "Shared a task"
                      : userStatus?.messageType === "EVENTS"
                        ? "Shared a events"
                        : JSON.stringify(userStatus?.body);
        if (userStatus?.type === 1) {
          if (userStatus?.id === messageDetails?.id) {
            recentChatList[recentID].lastmessage = userStatus;
            recentChatList[recentID].lastmsgText = msgText;
          }
        }

        if (userStatus?.type === 2) {
          if (userStatus?.id === messageDetails?.id) {
            recentChatList["con" + userStatus?.chatId].lastmessage = userStatus;
            recentChatList["con" + userStatus?.chatId].lastmsgText = msgText;
          }
        }
        store.dispatch({
          type: actionTypes.RECENT_MESSAGE_LIST,
          payload: {
            recentChatList: recentChatList,
            recentLoading: true

          }
        });
      }
      editMessageChat(null, userStatus);
    });

    this.eventEmit.on("allconnectedUserStatus", (userStatus: any) => {
    //  console.log(userStatus,"userStatus")
    //   store.dispatch({
    //     type: Types.PRESENCE_USER_STATUS,
    //     payload: {
    //       presenceUserStatus: userStatus

    //     }
    //   });
    });
    this.eventEmit.on("all_connected_user", (userStatus: any) => {
      store.dispatch({
        type: Types.PRESENCE_USER_STATUS,
        payload: {
          presenceUserStatus: userStatus

        }
      });

      const userDetails = userInfo();
      const queryParams: contactSync = { ext: 123, CallId: uuidv4() };
      contactService.getWorkcontact(queryParams);
    });

    this.eventEmit.on("userconnectionStatusChange", (userStatus: any) => {
      //presenceUpdateStatus(userStatus);
    });

    this.eventEmit.on("typing", chatTyping);
    this.eventEmit.on("typing_stopped", chatTypingStop);
    this.eventEmit.on("ai_assist_res", aiAssist);
  }
  public updateRecentChatSettings(settings: any) {
    this.socketConnection?.updateRecentChatSettings(settings)
  }

  public clearChatMessage(chatId: string) {
    this.socketConnection?.clearChatMessge(chatId);
  }

  public sendFileToGroup(message: any, chatWindowDetails: any, replyMsg?: any, list?: any) {
    let message1:any ={
      "fileName" : message.filename,
      "filesize" : message.size,
      "fileType" : message.mimetype,
      "filePath" : message.geturl
    }
    if (!message.hasOwnProperty("fileName")) {
      message['fileName'] = message1.fileName;
      message['filename'] ="";
    }
    if (!message.hasOwnProperty("filesize")) {
      message['filesize'] = message1.filesize;
      message['size'] ="";
    }
    if (!message.hasOwnProperty("fileType")) {
      message['fileType'] = message1.fileType;
      message['mimetype'] ="";
    }
    if (!message.hasOwnProperty("filePath")) {
      message['filePath'] = message1.filePath;
      message['geturl'] ="";
    }
    let { replyMessageDetails }: chats = store.getState().chatReducer;
    const userDetails = userInfo();
    const teamMembers = chatWindowDetails?.team_members?.replace(/\s/g, '').split(',');
    const teamMembersIndex = teamMembers?.indexOf(userDetails.fromID.toString())
    let reply: any = replyMsg?.isReply ? replyMsg?.replymessage : "";
    let thred = replyMsg?.isReply && (replyMsg?.replymessage?.message?.threadId !== "" && _.isUndefined(replyMsg?.replymessage?.message?.threadId) === false) ? replyMsg?.replymessage?.message?.threadId : replyMsg?.replymessage?.id
    let checkLink: any = checkLinkMessage(message?.text);
    let msgFormat = message;
    let listMsg: any = list === undefined ? chatWindowDetails : !_.isUndefined(list?.direction) && list?.direction === 'IN';
    let frdMsg: any = list?.message?.forward === true ? list?.message?.forward : false;
    let Type: any = imageFormat.indexOf(msgFormat?.fileType) > -1 ? "IMAGE" : "FILE";
    //uuid, chatType, senttime, fromid, sipid, teamid, messageBody
    teamMembers.splice(teamMembersIndex, 1);
    this.socketConnection?.newGroupChat(uuidv4(), 2, moment().valueOf(), userDetails.fromID.toString(),
      teamMembers.toString(), chatWindowDetails.team_id, {
      messageType: Type,
      body: message, replyMsgBody: reply, isReply: replyMsg?.isReply ? true : false,
      forward: listMsg ? true : frdMsg,
      isLink: checkLink ? true : false,
      threadId: replyMsg?.isReply ? thred : ""
    });
    replyMessageDetails.isReply && ChatService.onChangeReplyWindow(false, "");

  }

  public createGroupChat(teamDetail: any) {

    this.socketConnection?.createGroupChat(
      teamDetail.companyId, teamDetail.teamId
      , teamDetail.teamName, teamDetail.teamType,
      teamDetail.createdBy, teamDetail.description,
      teamDetail.processType, teamDetail.exceptGuest,
      teamDetail.postMsg, teamDetail.mention, teamDetail.members,
      teamDetail.integration, teamDetail.pinPost, teamDetail.teamGuid, teamDetail.photoInfo,
      teamDetail.teamIdPrefix, teamDetail.host);


  }

  public newMessageGroupSuccess = (message: any, text: any) => {

    if (message.data) {
      let contactRed = store.getState().contactReducer;
      let { teamContacsnew, allContacs }: any = contactRed;

      let teamKey: any = message.data.team_id_prefix + message.data.team_id;
      allContacs.push(message.data);

      Object.assign(teamContacsnew, { [teamKey]: message.data });
      store.dispatch({
        type: Types.TEAM_CONTACT_NEW,
        payload: {
          teamContacsnew: teamContacsnew,
          isTeamContactLoading: true
        }
      });
      store.dispatch({
        type: Types.ALL_CONTACT,
        payload: {
          allContacs: allContacs
        }
      });
      //  let toastInfo = message.data.admin_members.replace(" ", "");
      //toastOnlyHost(toastInfo, "Team created successfully");
      const userDetails = userInfo();

      this.socketConnection?.newGroupChat(uuidv4(), 2, moment().valueOf(), userDetails.fromID.toString(),
        message.data.team_members.replace(/\s/g, '').toString(), message.data.team_id, {
        messageType: "TEXT",
        body: text
      });

      setTimeout(() => {
        this.openChatWindow(message.data)
      }, 500)


    } else {
      toastInformation("Already Team Name Exists", "failure");
    }

  }

  public getUserPrescence = () => {
    new chatSDK.ChatRestService().userGetStatus()
      .then((data: any) => {
        if (data?.statusCode === 200) {
          //let USerstatus :any= data?.user_status?.status_msg;
          let activeStatus: any = data?.user_status?.status_indicator;
          const userInfo: any = Cookie.get();
          const userInfosess: any = sessionStorage.getItem("userinfo");
          if (userInfosess) {
            const cookieData = JSON.parse(userInfosess);
            cookieData.user_status = activeStatus;
            store.dispatch({
              type: Types.ADD_LOGIN,
              payload: {
                userdetails: cookieData
              }
            });
          }
        }
      });
  }
  public addTeamMember(memberData: any) {
    if (this.socketConnection) {
      this.socketConnection?.addMembersInGrp(memberData.companyId, memberData.teamId,
        memberData.teamMemberFromId, memberData.teamMemberSipId);
    }
  }

  public removeTeamMember(memberData: any) {
    if (this.socketConnection) {
      this.socketConnection?.removeMembersInGrp(memberData.companyId, memberData.teamId,
        memberData.teamMemberFromId, memberData.removeMembersSipId);
    }
  }

  public leaveMember(leavememberData: any) {
    if (this.socketConnection) {
      this.socketConnection?.membersLeaveInfo(leavememberData.companyId, leavememberData.teamId,
        leavememberData.leaveMemberSipId);
    }
  }
  public sendGroupChat(message: string, chatWindowDetails: any, mention?: any, replyMsg?: any) {
    let { replyMessageDetails }: chats = store.getState().chatReducer;
    const userDetails = userInfo();
    const toastReducer: any = store.getState().toastReducer;
    let link = checkLinkMessage(message);
    let reply: any = replyMsg?.isReply ? replyMsg?.replymessage : "";
    let thred = replyMsg?.isReply && (replyMsg?.replymessage?.message?.threadId !== "" && _.isUndefined(replyMsg?.replymessage?.message?.threadId) === false) ? replyMsg?.replymessage?.message?.threadId : replyMsg?.replymessage?.id
    let mesgType = Array.isArray(mention) && mention.length > 0 ? "AT_MENTION" : "TEXT";
    const teamMembers = chatWindowDetails?.team_members?.replace(/\s/g, '').split(',');
    const teamMembersIndex = teamMembers?.indexOf(userDetails?.fromID.toString())
    //uuid, chatType, senttime, fromid, sipid, teamid, messageBody
    teamMembers?.splice(teamMembersIndex, 1);

     if (toastReducer?.internet === true) {
      let messageDetails: any = {
        from: userDetails.fromID.toString(), sourceTimestamp: moment().valueOf(), to:  teamMembers?.toString(),
        chatId: chatWindowDetails?.team_id, message:
        {
          messageType: mesgType,
      body: message, isLink: link, replyMsgBody: reply,
      isReply: replyMsg?.isReply ? true : false, threadId: replyMsg?.isReply ? thred : "",
      mentionID: Array.isArray(mention) && mention.length > 0 ? mention.toString() : mention
        },
        id: uuidv4()
      };
      messageDetails.deliveryStatus = 1;
      messageDetails.readStatus = 0;
      messageDetails.createdAt = new Date().toISOString();
      messageDetails.updatedAt = new Date().toISOString();
      messageDetails.timestamp = moment().valueOf();
      // messageDetails.fromcaller_details = chatWindowDetails?.sip_login_id ? workContactsnew[chatWindowDetails?.sip_login_id] :
      //   teamContacsnew["con" + chatWindowDetails?.team_id];
      messageDetails.type = chatWindowDetails?.sip_login_id ? 1 : 2;
       DraftService.addFailedMessage(chatWindowDetails, messageDetails);
     } else {
        this.socketConnection?.newGroupChat(uuidv4(), 2, moment().valueOf(), userDetails.fromID.toString(),
        teamMembers?.toString(), chatWindowDetails?.team_id, {
        messageType: mesgType,
        body: message, isLink: link, replyMsgBody: reply,
        isReply: replyMsg?.isReply ? true : false, threadId: replyMsg?.isReply ? thred : "",
        mentionID: Array.isArray(mention) && mention.length > 0 ? mention.toString() : mention
      });
      replyMessageDetails.isReply && ChatService.onChangeReplyWindow(false, "");
      chatwindowDetailsPageChange(chatWindowDetails);
    }
  }
  public grouphistory(historyGroup: any) {
    this?.socketConnection?.getGroupChatHistory(
      historyGroup.chatId, historyGroup.id, historyGroup.offset, historyGroup.orderType,
      historyGroup.startDateTime, historyGroup.endDateTime);
  }
  public chatEditMessage(data: any, msg: string) {
    let self = this;
    console.log(data, "ppopo")
    // let replyMsgBody:any =data?.message?.isReply === true ? data?.message?.replyMsgBody : "" ;
    // let message: any = { messageType: "TEXT", body: msg, isEdit: true, replyMsgBody: replyMsgBody,
    // isReply: data?.message?.isReply ? true : false }
    let messageBody = data.message;
    if (data.message.messageType === 'TEXT' || data.message.messageType === 'AT_MENTION') {
      messageBody.body = msg;
    }
    // messageBody.body= msg;
    messageBody.isEdit = true;
    self?.socketConnection?.chatEditMsg(data?.id, data?.to, data?.from, moment().valueOf(), data?.chatId, messageBody);
  }

  public fetchChatHistory(chatWindowDetails: any) {
    let self = this;
    self?.openContactWindow(chatWindowDetails);
    if (chatWindowDetails && chatWindowDetails?.sip_login_id) {
      const userDetails = userInfo();
      const chatId = generateChatID(userDetails.fromID, chatWindowDetails?.sip_login_id)
    //  setTimeout(() => {
      self?.getChatHistory(chatId, "");
    //  }, 1000); 
    } else if (chatWindowDetails && chatWindowDetails?.team_id) {

      let input: any = {};
      input.chatId = chatWindowDetails?.team_id;
      input.id = "";
      input.offset = 25;
      input.orderType = 0;
      input.startDateTime = '';
      input.endDateTime = '';
    //  setTimeout(() => {
      self?.grouphistory(input);
    //  }, 1000); 
    }
    //clearChatList(chatWindowDetails);
  }
  public getChatHistory(chatId: string, id: string) {
    this.socketConnection?.getChatHistory(chatId, id);
  }

  public likeMessageInfo(likeDetails: any) {
    if (this.socketConnection) {
      this.socketConnection?.likeMsg(likeDetails.id, likeDetails.likeStatus);
    }
  }

  public savedChatList(savedListData: any) {
    if (this.socketConnection) {
      this.socketConnection?.mySpaceSavedList(savedListData);
    }
  }

  public scrollToTeamArchive(chatWindowDetails: any) {
    let self:any=this;
    let { messageList, scrollPos }: any = store.getState().chatSocketReducerState;
    let chatWin = document.getElementById('chatWindow') || null;
    if (messageList.length > 0 && chatWin) {
      const scrollPosNew = document.getElementById('chatWindow')?.scrollHeight;
      let input: any = {};
      input.chatId = chatWindowDetails?.team_id;
      input.id = messageList[0].id;
      input.offset = 25;
      input.orderType = 0;
      input.startDateTime = '';
      input.endDateTime = '';
      if (scrollPosNew !== scrollPos) {
        store.dispatch({
          type: actionTypes.UPDATE_ARCHIVEID,
          payload: {
            archiveID: messageList[0].id,
            scrollPos: scrollPosNew,
            messageLoading: true
          }
        });
        self?.grouphistory(input);
      }

    }

  }
  public scrollToArchive(chatId: string) {
    let { messageList, scrollPos }: any = store.getState().chatSocketReducerState;
    let chatWin = document.getElementById('chatWindow') || null;
    if (messageList.length > 0 && chatWin) {
      const scrollPosNew = document.getElementById('chatWindow')?.scrollHeight;
      if (scrollPosNew !== scrollPos) {
        store.dispatch({
          type: actionTypes.UPDATE_ARCHIVEID,
          payload: {
            archiveID: messageList[0].id,
            scrollPos: scrollPosNew,
            messageLoading: true
          }
        })
        this.socketConnection?.getChatHistory(chatId, messageList[0].id);
      }
    }
  }
  public forwardFileMessage(fileMessage: any, list: any) {
    let message: any = fileMessage?.message;
    let listMsg: any = fileMessage === undefined ? list : !_.isUndefined(fileMessage?.direction) && fileMessage?.direction === 'IN';
    let frdMsg: any = fileMessage?.message?.forward === true ? fileMessage?.message?.forward : false;
    //let frdMsg:any = message?.forward === true ? message?.forward : false;
    const userDetails = userInfo();
    const toID = list?.sip_login_id?.toString() ? list?.sip_login_id?.toString() : userDetails.toID.toString();
    // delete message.isSave;
    // delete message.liked;
    //message['forward'] = fileMessage.direction === "IN" ? true: frdMsg

    this.socketConnection.newChat({
      id: uuidv4(),
      from: userDetails.fromID.toString(),
      sourceTimestamp: moment().valueOf(),
      to: toID,
      chatId: generateChatID(userDetails.fromID, toID),
      message: {
        messageType: message.messageType, body: message.body, replyMsgBody: '', isLink: message.isLink, isEdit: false,
        isReply: fileMessage.isReply ? true : false, threadId: message.threadId, forward: listMsg ? true : frdMsg
      }
    });
  }
  public forwardGroupMessage(message: any, list: any, data: any) {

    let mesgType = data?.message?.messageType === 'AT_MENTION' ? "AT_MENTION" : "TEXT";
    const userDetails = userInfo();
    this.socketConnection?.newGroupChat(uuidv4(), 2, moment().valueOf(), userDetails.fromID.toString(),
      list.team_members.replace(/\s/g, '').toString(), list.team_id, {
      messageType: mesgType,
      body: message,
      mentionID: data?.message?.messageType === 'AT_MENTION' ? data?.message?.mentionID : '',
      forward: list ? true : false
    });

  }
  public updateTeamMembers(team: Array<any>) {
    store.dispatch({
      type: Types.UPDATE_TEAM_MEMBER,
      payload: {
        newUserMembers: team
      }
    });
  }

  public newMessageFileAttach(fileName: any, fileType: any, filesize: any, filePath: any, chatWindowDetails: any, status?: boolean, textMessage?: string,cloudFiles?:boolean) {
    const userDetails = userInfo();
    const fromUser = parseInt(userDetails.fromID);
    const fromCallerDetails = userInfo().workContactObj[fromUser];
    let Type: any = imageFormat.indexOf(fileType) > -1 ? "IMAGE" : "FILE";
    const messageBody = {
      fileName: fileName,
      fileType: fileType,
      filesize: filesize,
      filePath: filePath,
      text: textMessage,
      isCloudfiles: cloudFiles || false 
    }
    console.log("messageBodymessageBody", messageBody);

    let mesgDetails = {
      id: uuidv4(),
      from: userDetails.fromID.toString(),
      sourceTimestamp: moment().valueOf(),
      to:(messageBody.fileType === "mp3" ? chatWindowDetails?.sip_login_id?.toString() : chatWindowDetails?.sipid?.toString()),
      chatId: generateChatID(userDetails.fromID, messageBody.fileType === "mp3" ? chatWindowDetails?.sip_login_id?.toString() : chatWindowDetails?.sipid?.toString()),
      message: {
        messageType: Type,
        body: { ...messageBody }
      },
      fromcaller_details: fromCallerDetails
    };    
    this.socketConnection?.newChat(mesgDetails);
    if (status) {
      let { messageList }: any = store.getState().chatSocketReducerState;
      store.dispatch({
        type: actionTypes.MESSAGE_LIST,
        payload: {
          messageList: [...messageList, mesgDetails],
          messageLoading: false
        }
      });
    }

  }
  public newFileAttach(fileName: any, fileType: any, filesize: any, filePath: any, textMessage: string, replyMsg?: any,cloudFiles?:boolean) {
    let { replyMessageDetails }: chats = store.getState().chatReducer;
    const userDetails = userInfo();
    let Type: any = imageFormat.indexOf(fileType) > -1 ? "IMAGE" : "FILE";
    let reply: any = replyMsg?.isReply ? replyMsg?.replymessage : "";
    let thred = replyMsg?.isReply && (replyMsg?.replymessage?.message?.threadId !== "" && _.isUndefined(replyMsg?.replymessage?.message?.threadId) === false) ? replyMsg?.replymessage?.message?.threadId : replyMsg?.replymessage?.id
    let checkLink: any = checkLinkMessage(textMessage);

    const messageBody = {
      fileName: fileName,
      fileType: fileType,
      filesize: filesize,
      filePath: filePath,
      text: textMessage,
      isCloudfiles: cloudFiles || false
    }
    this.socketConnection.newChat({
      id: uuidv4(),
      from: userDetails.fromID.toString(),
      sourceTimestamp: moment().valueOf(),
      to: userDetails.toID.toString(),
      chatId: generateChatID(userDetails.fromID, userDetails.toID),
      message: {
        messageType: Type,
        body: { ...messageBody },
        replyMsgBody: reply,
        isReply: replyMsg?.isReply ? true : false,
        isLink: checkLink === true ? true : false,
        isEdit: false,
        threadId: replyMsg?.isReply ? thred : ""
      }
    });
    replyMessageDetails.isReply && ChatService.onChangeReplyWindow(false, "");
  }

  public openContactWindow(contactDetails: any) {


    store.dispatch({
      type: Types.SET_CONTACT_WINDOW,
      payload: {
        chatWindowDetails: contactDetails
      }
    });
  }


  public openChatWindow(InputcontactDetails: any, history?: any, contact?: any, page?: any) {
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    let { landingPage }: LoginState = store.getState().loginReducer;
    let details: any = [];
    let deletegroupLandingpage = localStorage.getItem("deletegroupLandingpage");
    let self = this;
    if (InputcontactDetails?.team_id) {
      let memberList = InputcontactDetails?.team_members && InputcontactDetails?.team_members?.replace(/\s/g, '').split(',');
      Array.isArray(memberList) && memberList.map((mem: any) => {
        let conDetails: any = getTeamMemberContact(mem);
        conDetails !== undefined && conDetails !== null && details.push(conDetails);
      });

    }
    if (document.visibilityState === "visible") {
      //console.log("tab receivechat active");
      if (page === 'contactpage') {
        clearArchiveMessage();
      }
    } else {
      clearArchiveMessage();
    }

    if (InputcontactDetails?.team_id) {
      InputcontactDetails = { ...InputcontactDetails, teammembersdetails: details || [] };
      let input: any = {};
      input.chatId = InputcontactDetails?.team_id;
      input.id = '';
      input.offset = 25;
      input.orderType = 0;
      input.startDateTime = '';
      input.endDateTime = '';

      self?.grouphistory(input);
      store.dispatch({
        type: Types.OPEN_CHAT_WINDOW,
        payload: {
          isChatWindow: true,
          chatWindowDetails: InputcontactDetails,
          isMySpace: false,
          isNewMessageWindow: false,
          newUserMembers: []
        }
      });
      const userDetails = userInfo();
      if (_.isUndefined(recentChatList["con" + InputcontactDetails?.team_id]) === false &&
        _.isUndefined(recentChatList["con" + InputcontactDetails?.team_id]?.settings?.markRead) === false && userDetails.fromID &&
        _.isUndefined(recentChatList["con" + InputcontactDetails?.team_id]?.settings?.markRead?.["s" + userDetails.fromID]) === false) {
        recentChatList["con" + InputcontactDetails?.team_id].settings.markRead["s" + userDetails.fromID] = 1;
        store.dispatch({
          type: actionTypes.RECENT_MESSAGE_LIST,
          payload: {
            recentChatList: recentChatList,
            recentLoading: true
          }
        });
        if ((recentChatList["con" + InputcontactDetails?.team_id]?.settings?.muteTimeStamp?.["s" + userDetails.fromID]) !== "") {
          let stamp = recentChatList["con" + InputcontactDetails?.team_id]?.settings?.muteTimeStamp?.["s" + userDetails.fromID]
          let mutetime = stamp?.timeStamp !== "" ? getTimeDiffer(stamp?.timeStamp) : ""
          if (mutetime < 0) {
            let chatDetails = {
              chatId: InputcontactDetails?.team_id,
              settingsKey: "isMuted",
              muteTimestamp: "",
              type: 2,
              status: 0
            };
            self?.updateRecentChatSettings(chatDetails)
          }

        }
        let chatDetails = {
          chatId: InputcontactDetails?.team_id,
          settingsKey: "markRead",
          status: 1
        };
        //this.updateRecentChatSettings(chatDetails)
      }
    }
    else {
      // this.CreateChat(InputcontactDetails?.sip_login_id);
      if (recentChatList && InputcontactDetails?.sip_login_id && (contact?.chatId || InputcontactDetails?.chatId)) {
        const userDetails = userInfo();
        if (_.isUndefined(recentChatList[InputcontactDetails?.sip_login_id]) === false &&
          _.isUndefined(recentChatList[InputcontactDetails?.sip_login_id]?.settings?.markRead) === false && userDetails.fromID &&
          _.isUndefined(recentChatList[InputcontactDetails?.sip_login_id]?.settings?.markRead?.["s" + userDetails.fromID]) === false) {

          recentChatList[InputcontactDetails?.sip_login_id].settings.markRead["s" + userDetails.fromID] = 1;
          store.dispatch({
            type: actionTypes.RECENT_MESSAGE_LIST,
            payload: {
              recentChatList: recentChatList,
              recentLoading: true
            }
          });
          if ((recentChatList[InputcontactDetails?.sip_login_id]?.settings?.muteTimeStamp && recentChatList[InputcontactDetails?.sip_login_id]?.settings?.muteTimeStamp?.["s" + userDetails.fromID]) !== "") {
            let stamp = recentChatList[InputcontactDetails?.sip_login_id]?.settings?.muteTimeStamp?.["s" + userDetails.fromID]
            let mutetime = stamp?.timeStamp !== "" ? getTimeDiffer(stamp?.timeStamp) : ""

            if (mutetime < 0) {
              let chatDetails = {
                chatId: contact?.chatId,
                settingsKey: "isMuted",
                muteTimestamp: "",
                type: 1,
                status: 0
              };
              self?.updateRecentChatSettings(chatDetails)
            }
          }

          // let chatDetails = {
          //   chatId: contact?.chatId,
          //   settingsKey: "markRead",
          //   status: 1
          // };
          // this.updateRecentChatSettings(chatDetails)
        }
        self?.getChatHistory(contact?.chatId, "");
        InputcontactDetails = { ...InputcontactDetails, chatId: contact?.chatId };
      }
    }

    store.dispatch({
      type: Types.GET_SAVED_LIST,
      payload: {
        isSavedList: false,
        savedListDetails: []
      }
    });

    store.dispatch({
      type: Types.OPEN_CHAT_WINDOW,
      payload: {
        isChatWindow: true,
        chatWindowDetails: InputcontactDetails,
        isMySpace: false,
        isNewMessageWindow: false,
        newUserMembers: []
      }
    });
    store.dispatch({
      type: Types.CHAT_SEARCH_STORE,
      payload: {
        isSearch: false
      }
    });
    store.dispatch({
      type: actionTypes.HISTORY_LOADING,
      payload:{
          historyLoading: false,
          historyFailedmsg:[]
      }
  })
    if (history) { history.push("/chats") };
    store.dispatch({
      type: actionTypes.MESSAGE_LOADING,
      payload: {
        messageLoading: true
      }
    });
    if (page === 'contactpage') {
      store.dispatch({
        type: Types.GET_LINK_LIST,
        payload: {
          isLink: false,
          linkListDetails: []
        }
      });
      store.dispatch({
        type: actionTypes.HISTORY_LOADING,
        payload:{
            historyLoading: false,
            historyFailedmsg:[]
        }
    })
    }
    if (landingPage) {
      if (deletegroupLandingpage === 'landingopen') {
        store.dispatch({
          type: Types.LANDING_PAGE,
          payload: {
            landingPage: true
          }
        });
        localStorage.removeItem('deletegroupLandingpage');
      } else {
        store.dispatch({
          type: Types.LANDING_PAGE,
          payload: {
            landingPage: false
          }
        });
      }

    }
  }

  public membersRoleChange = (roleInfo: any) => {
    this.socketConnection?.membersRoleChangeInfo(
      roleInfo.companyId,
      roleInfo.teamId,
      roleInfo.roleType,
      roleInfo.sipId
    );
  }

  public bookMarkMesseage = (savedMsgDetails: any) => {
    if (this.socketConnection) {
      this.socketConnection?.savedChatMsgInfo(savedMsgDetails);

      setTimeout(() => {
        this.socketConnection?.getSaveChatList({});
      }, 500)
    };
  };

  public fileListData = (fileListDetails: any) => {
    if (this.socketConnection) {
      this.socketConnection?.fileChatList(fileListDetails);
    };
  };

  public savedChatlistSingleUser = (savedChatListData: any) => {
    if (this.socketConnection) {
      this.socketConnection?.savedChatList(savedChatListData);
    }
  };

  public linkChatList = (linkListData: any) => {
    if (this.socketConnection) {
      this.socketConnection?.linkChatList(linkListData);
    }
  };

  public deleteForme(id: string) {
    this.socketConnection?.deleteForme(id);
  }
  public deleteForEveryone(id: string) {
    if (this.socketConnection) {
      this.socketConnection?.deleteForEveryOne(id);
    }
  }

  public mySpaceSaved = (mySpaceInput: any) => {

    if (this.socketConnection) {
      this.socketConnection?.mySpaceSavedList(mySpaceInput);
    }
  }

  public getmySpaceFileList = (mySpaceInput: any) => {

    if (this.socketConnection) {
      this.socketConnection?.mySpacefileList(mySpaceInput);
    }
  }

  public getmySpaceLinkList = (mySpaceInput: any) => {

    if (this.socketConnection) {
      this.socketConnection?.mySpaceLinkList(mySpaceInput);
    }
  }
  // public static async replyHover(type: boolean,data:any){
  //   store.dispatch({
  //     type: Types.REPLY_CHAT_MESSAGE,
  //     payload: {

  //       isReplyChat:type,
  //       replyChatData:data
  //     }
  //   });

  //   scrollIntoView(data.id);

  //   store.dispatch({
  //     type: Types.FILE_CHAT_MESSAGE,
  //     payload: {
  //       isviewContactFile:false,
  //       contactFileData: {}
  //     }
  //   });
  //   store.dispatch({
  //     type: Types.SAVE_CHAT_MESSAGE,
  //     payload: {
  //       isSaveChat: false,
  //       saveChatData: {}
  //     }
  //   });

  // }
  // public static async deleteHover(type: boolean,data:any){

  //   store.dispatch({
  //     type: Types.DELETE_CHAT_MESSAGE,
  //     payload: {
  //       isDeleteChat: type,
  //       deleteChatData: data
  //     }
  //   });

  //   //scrollIntoView(data.id);
  //   store.dispatch({
  //     type: Types.SAVE_CHAT_MESSAGE,
  //     payload: {
  //       isSaveChat: false,
  //       saveChatData: {}
  //     }
  //   });
  //   store.dispatch({
  //     type: Types.REPLY_CHAT_MESSAGE,
  //     payload: {

  //       isReplyChat:false,
  //       replyChatData:{}
  //     }
  //   });
  //   store.dispatch({
  //     type: Types.FILE_CHAT_MESSAGE,
  //     payload: {
  //       isviewContactFile:false,
  //       contactFileData: {}
  //     }
  //   });
  // }
  // public static async filesHighlight(type: boolean,data:any){
  //   store.dispatch({
  //     type: Types.FILE_CHAT_MESSAGE,
  //     payload: {
  //       isviewContactFile:type,
  //       contactFileData:data
  //     }
  //   });
  //   scrollIntoView(data.id);
  //   store.dispatch({
  //     type: Types.SAVE_CHAT_MESSAGE,
  //     payload: {
  //       isSaveChat: false,
  //       saveChatData: {}
  //     }
  //   });

  //   store.dispatch({
  //     type: Types.REPLY_CHAT_MESSAGE,
  //     payload: {

  //       isReplyChat:false,
  //       replyChatData:{}
  //     }
  //   });
  // }
  public saveChatHighlight = (type: boolean, data: any) => {


    store.dispatch({
      type: Types.SAVE_CHAT_MESSAGE,
      payload: {
        isSaveChat: type,
        saveChatData: data
      }
    });
    scrollIntoView(data?.id);
    setTimeout(() => {
      store.dispatch({
        type: Types.SAVE_CHAT_MESSAGE,
        payload: {
          isSaveChat: false,
          saveChatData: {}
        }
      });
    }, 3000);

    // store.dispatch({
    //   type: Types.FILE_CHAT_MESSAGE,
    //   payload: {
    //     isviewContactFile:false,
    //     contactFileData: {}
    //   }
    // });
    // store.dispatch({
    //   type: Types.REPLY_CHAT_MESSAGE,
    //   payload: {

    //     isReplyChat:false,
    //     replyChatData:{}
    //   }
    // });
  }

  public createNewMessageGroup(textMessage: any) {
    let self:any=this;
    let { userdetails }: loginReducerState = store.getState().loginReducer;
    let { newUserMembers }: chatwindowDetails = store.getState().chatWindowReducer;
    let addmember: any = [];
    let addmemberNames: any = [];
    newUserMembers.map((contacts: any, index: any) => {
      addmember.push(contacts.sip_login_id);
      addmemberNames.push(contacts?.caller_id);

    })

    let { host_address, company_id } = userdetails;

    let createTeamDetails: any = {};

    createTeamDetails.companyId = company_id;
    createTeamDetails.teamId = 0
    createTeamDetails.teamName = addmemberNames.join();
    createTeamDetails.teamType = 1;
    createTeamDetails.description = "";
    createTeamDetails.createdBy = userdetails.sip_login_id;
    createTeamDetails.exceptGuest = 0;
    createTeamDetails.postMsg = 1;
    createTeamDetails.mention = 0;
    createTeamDetails.integration = 0;
    createTeamDetails.pinPost = 0;
    createTeamDetails.members = addmember.join();
    createTeamDetails.photoInfo = "";
    createTeamDetails.teamGuid = ""
    createTeamDetails.processType = 1;
    createTeamDetails.teamIdPrefix = "con";
    createTeamDetails.host = host_address;
    createTeamDetails.message = textMessage;



    self?.createNewMessageGroupChat(createTeamDetails);

  }

  public createNewMessageGroupChat(teamDetail: any) {
    this.socketConnection?.createNewMessageGroupChat(
      teamDetail.companyId, teamDetail.teamId
      , teamDetail.teamName, teamDetail.teamType,
      teamDetail.createdBy, teamDetail.description,
      teamDetail.processType, teamDetail.exceptGuest,
      teamDetail.postMsg, teamDetail.mention, teamDetail.members,
      teamDetail.integration, teamDetail.pinPost, teamDetail.teamGuid, teamDetail.photoInfo,
      teamDetail.teamIdPrefix, teamDetail.host, teamDetail.message);
  }


  public groupCallSendEvent(sendingInfo: any) {
    this.socketConnection?.groupCallEvent(sendingInfo);
  }
  
  public mergeCallSendEvent(sendingInfo: any) {
    this.socketConnection?.mergeCallEvent(sendingInfo);
  }

  public groupCallMuteStatus(sendingInfo: any) {
    this.socketConnection?.groupCallMute(sendingInfo);
  }

  public getGroup_CallInfo(groupId: any) {
    this.socketConnection?.getGroupInfo(groupId);
  }
  public getActiveGroupCalls() {
   // this.socketConnection && this.socketConnection?.runningGroupCalls({});
  }

  public getCallConnected() {
   this.socketConnection && this.socketConnection?.callConnected({});
  }
  public getFlipCall(callId: string, caller_id: string,toNumber: string, deviceType: string, uid: string,from:string) {


   this.socketConnection && this.socketConnection?.flipCall({ callId, caller_id, from, deviceType, uid});
  }

  // public grpCallSpeechInfo(groupInfo:any){  
  //   this.socketConnection?.grpCallSpeechStatus(groupInfo);
  // }
  public switchToGroupCall(header: any) {
    this.socketConnection?.switchToGroup(header);
  }
  public groupCallSpeechStatus(value: any) {
    this.socketConnection?.grpCallSpeechStatus(value);
  }
  // public callConnected(value: any) {
  //   this.socketConnection?.callConnected(value);
  // }

  public RingingNotificationStopStatus(meetingId: any) {
    if (this.socketConnection) {
      this.socketConnection?.stopRingingNotification(meetingId);
    }
  }
  public updateGroupCallHost(teamId: any, ext: string) {
    let sendingReq: any = { TeamID: teamId, Host: ext }
    this.socketConnection?.updatingHost(sendingReq);
  }

  public sendVideoRequest(data: any) {
    this.socketConnection.videoCallRequest(data)
  }

  public senddirectVideoRequest(data: any) {
    this.socketConnection.meetvideoCallRequest(data)
  }
  public aiSuggestions(data:any){
    console.log("this.socketConnection>",this.eventEmit);
    this.socketConnection.aiAssistSend(data);
  }
}
